import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { SpinnerService } from '../../../services/spinner.service';
import { ApiBaseAttribute, ApiSetFacilityAttributesRequest } from '../../../api-client-module';
import { ProjectLanguage } from '../../../firestore-models/project-language';

import { ConfigurationService } from '../../../configuration.service';
import { ApiClientService } from '../../../api-client.service';
import { AppConst } from '../../../app-const';
import { MultiNameDialogComponent } from '../../../common/multi-name-dialog/multi-name-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface FacilityAttributeDialogData {
  change_type: number;
  facilityAttribute?: ApiBaseAttribute;
}

@Component({
  selector: 'app-facility-attribute-dialog',
  templateUrl: './facility-attribute-dialog.component.html',
  styleUrls: ['./facility-attribute-dialog.component.css'],
  standalone: false,
})
export class FacilityAttributeDialogComponent implements OnInit {

  projectId: string;
  //施設属性情報
  facilityAttribute?: ApiBaseAttribute;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  //展示属性情報フォーム
  facilityAttributeFormGroup!: FormGroup;
  facilityAttributeIdControl!: FormControl;
  facilityAttributeNameControl!: FormControl;

  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<FacilityAttributeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FacilityAttributeDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.projectId = this.configurationService.getProjectId();
   }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.facilityAttribute = this.data.facilityAttribute;
    if (!this.facilityAttribute) {
      this.facilityAttribute = {
        attribute_id: '',
        attribute_names: [],
        project_id: this.projectId,
        enabled: true
      };
      this.isAdded = true;
    }
    this.createForm();
    this.facilityAttributeIdControl = this.facilityAttributeFormGroup.get('facilityAttributeId') as FormControl;
    this.facilityAttributeNameControl = this.facilityAttributeFormGroup.get('facilityAttributeName') as FormControl;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToFacilityAttributeId() {
    return this.facilityAttributeIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.facilityAttributeIdControl.hasError('pattern')
        ? this.translate.instant('半角数字')
        : '';
  }

  public getErrorMessageToFacilityAttributeName() {
    return this.facilityAttributeNameControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.facilityAttributeFormGroup = this.formBuilder.group(
      {
        facilityAttributeId: [this.facilityAttribute!.attribute_id, [Validators.required, Validators.pattern('^[0-9]+$')]],
        facilityAttributeName: [this.facilityAttribute!.attribute_names, [Validators.required]],
      }
    );
  }

  //更新ボタン
  addFacilityAttribute(): void {
    if (this.facilityAttributeFormGroup.valid) {
      this.facilityAttribute!.attribute_id = this.facilityAttributeIdControl.value;
      this.facilityAttribute!.attribute_names = this.facilityAttributeNameControl.value;
      if (this.facilityAttribute) {
        let request: ApiSetFacilityAttributesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          attributes: [this.facilityAttribute]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setFacilityAttributes(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //属性名称ダイアログ
  openAttributeNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.facilityAttribute!.attribute_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facilityAttribute!.attribute_names = result;
        this.facilityAttributeNameControl.setValue(this.facilityAttribute!.attribute_names);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
